import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface ICarOrVanAvailability {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  noCarsVans?: number | null;
  oneCar?: number | null;
  twoCars?: number | null;
  threeOrMoreCars?: number | null;
}

export const defaultValue: Readonly<ICarOrVanAvailability> = {};
